import Button from "@marginly/ui/components/button";
import T from "@marginly/ui/components/typography";
import NextLink from "next/link";

import Space from "../../common/space";
import {
  HowToGrid,
  StageMedia,
  StageUnit,
  TagsUnit,
  TextCentered,
} from "../styled";

const HowTo = () => {
  return (
    <section>
      <TextCentered>
        <T headerL>How to get Sparks now</T>
      </TextCentered>

      <Space height={80} heightMobile={48} />
      <HowToGrid>
        <StageUnit className="current">
          <TagsUnit className="accent">
            <img src="/images/airdrop/deposit-2.svg" alt="" />
            Now
          </TagsUnit>
          <Space height={32} heightMobile={32} />
          <T headerM>2&times; Sparks for liquidity bootstrap</T>
          <Space height={12} heightMobile={12} />
          <T body>
            Deposit ETH or stablecoins in our pools to double your Sparks
            rewards
          </T>
          <Space height={58} heightMobile={58} />
          <StageMedia src="/images/airdrop/stage-1.png" alt="" />
        </StageUnit>

        <StageUnit className="next">
          <TagsUnit>
            <img
              src="/images/airdrop/clock.svg"
              alt=""
              style={{ filter: `invert(1)` }}
            />
            Soon
          </TagsUnit>
          <Space height={32} heightMobile={32} />
          <T headerM>Up to 150% APY plus Sparks</T>
          <Space height={12} heightMobile={12} />
          <T body>
            Use Pendle Principal Tokens tokens to boost your restaking APY
            and&nbsp;earn&nbsp;Sparks
          </T>

          <StageMedia src="/images/airdrop/stage-2.png" alt="" />
        </StageUnit>
      </HowToGrid>
    </section>
  );
};

export default HowTo;
